module.exports = __webpack_public_path__ + "img/banner.6475d53d.png";